import PropTypes from 'prop-types';

var SvgChartContextMixin = {
  contextTypes: {
    /** Translate point coordinates from chart coordinate to SVG coordinate*/
    getPoint: PropTypes.func,
    /** Shadow filter url*/
    getLineShadowFilterUrl: PropTypes.func
  }
};


module.exports = SvgChartContextMixin;
